import { useEffect, useRef } from "react";
import { metadataAPI } from "../api/metadata";
import { useWhoAmI } from "./useWhoAmI";

/**
 * Persists the current (concern, candidate) into user metadata (`recentProfileVisits`,
 * max 3) once per loaded concern/candidate combo when the user is logged in.
 */
export function useRecordProfileVisit() {
  const { confirmedLoggedIn, concernId, whoAmI } = useWhoAmI();
  const candidateId = whoAmI?.idCandidate;
  const lastSentRef = useRef<string | null>(null);

  useEffect(() => {
    if (!confirmedLoggedIn || !concernId || concernId <= 0) return;
    if (!candidateId || candidateId <= 0) return;
    const key = `${concernId}:${candidateId}`;
    if (lastSentRef.current === key) return;
    lastSentRef.current = key;

    void (async () => {
      try {
        metadataAPI.recordProfileVisit({ concernId, candidateId });
      } catch {
        /* ignore */
      }
    })();
  }, [confirmedLoggedIn, concernId, candidateId]);
}
